/**
 * Collapse exact same service+date rows; keep recent visit lines for the welcome list.
 */
export function recentPreviousServices(items = [], limit = 5) {
  const seen = new Set();
  const out = [];
  for (const item of Array.isArray(items) ? items : []) {
    const name = String(item?.service_name || item?.name || '').trim();
    if (!name) continue;
    const date = String(item?.selected_at || '').slice(0, 10);
    const key = `${name.toLowerCase()}|${date}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({
      id: item?.id || key,
      service_name: name,
      selected_at: item?.selected_at || date,
    });
    if (out.length >= limit) break;
  }
  return out;
}

/**
 * Collapse repeated service history rows into unique services with count + latest date.
 */
export function summarizePreviousServices(items = []) {
  const map = new Map();
  (Array.isArray(items) ? items : []).forEach((item) => {
    const name = String(item?.service_name || item?.name || '').trim();
    if (!name) return;
    const key = name.toLowerCase();
    const date = item?.selected_at || '';
    const prev = map.get(key);
    if (!prev) {
      map.set(key, {
        id: key,
        service_name: name,
        selected_at: date,
        count: 1,
      });
      return;
    }
    prev.count += 1;
    if (String(date) > String(prev.selected_at || '')) {
      prev.selected_at = date;
    }
  });
  return Array.from(map.values()).sort((a, b) =>
    String(b.selected_at || '').localeCompare(String(a.selected_at || '')),
  );
}
